//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FormNavigation
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class FormNavigation {

    //Common fields	
    display_order = 0;
    form_display = "Link Display";
    form_route = null;
    form_type = "navigation";


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //Standard navigation link creation is three values, so let's add that to the constructor
    //  route<string>:  //Set to null for a link that is WIP
    constructor(display, route, order) {
        if (display) { this.form_display = display; }
        if (route) { this.form_route = route; }
        if (order) { this.display_order = order; };
    };

}